(function () {
  // hover/focus a rail item -> show that family; hover/click a tier -> show its three towels
  function wire(fly) {
    var ris = [].slice.call(fly.querySelectorAll('.rgf__ri')), fams = [].slice.call(fly.querySelectorAll('.rgf__fam')), t = null;
    function showFam(i) {
      ris.forEach(function (r, k) { r.classList.toggle('is-on', k === i); });
      fams.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
    }
    ris.forEach(function (r, i) {
      r.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { showFam(i); }, 70); });
      r.addEventListener('mouseleave', function () { clearTimeout(t); });
      r.addEventListener('focus', function () { showFam(i); });
    });
    fams.forEach(function (fam) {
      var tiers = [].slice.call(fam.querySelectorAll('.rgf__tier')), tps = [].slice.call(fam.querySelectorAll('.rgf__tp'));
      function showTier(i) {
        tiers.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        tps.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      }
      tiers.forEach(function (b, i) { b.addEventListener('mouseenter', function () { showTier(i); }); b.addEventListener('click', function () { showTier(i); }); b.addEventListener('focus', function () { showTier(i); }); });
    });
  }
  document.querySelectorAll('.rgf').forEach(wire);
})();
